<template>
    <div class="member-page">
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-user"></i> {{ $t('navMenu.220') }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入手机号或会员名称" class="handle-input mr10" clearable @clear="handleSearch"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="margin-left:auto" icon="el-icon-refresh" plain @click="handleRefresh">{{ $t('common.refresh') }}</el-button>
                <el-button type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}</el-button>
            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable" header-cell-class-name="table-header" row-key="id">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="120" align="center" fixed="left"></el-table-column>
                <el-table-column prop="name" label="会员名称" min-width="110" align="center" fixed="left"></el-table-column>
                <!-- 状态列 -->
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="statusTagType(scope.row.status)" size="small" effect="dark">{{ statusText(scope.row.status) }}</el-tag>
                    </template>
                </el-table-column>
                <!-- 性别列 -->
                <el-table-column label="性别" width="70" align="center">
                    <template slot-scope="scope">
                        <span :style="{ color: genderColor(scope.row.gender) }">{{ genderText(scope.row.gender) }}</span>
                    </template>
                </el-table-column>
                <!-- 标签列（根据tags_color显示对应颜色） -->
                <el-table-column label="标签" min-width="150" align="center">
                    <template slot-scope="scope">
                        <span
                            v-for="tag in parseTags(scope.row.tags)"
                            :key="tag"
                            class="tag-item"
                            :style="{ backgroundColor: tagColor(tag) }"
                        >{{ tagName(tag) }}</span>
                        <span v-if="!scope.row.tags" class="text-muted">--</span>
                    </template>
                </el-table-column>
                <el-table-column label="会员卡到期日期" min-width="160" align="center">
                    <template slot-scope="scope">
                        <el-tooltip v-if="isExpireSoon(scope.row.expire_date)" :content="expireTip(scope.row.expire_date)" placement="top">
                            <span class="expire-warn" :class="{ 'expire-danger': expireDays(scope.row.expire_date) <= 7 }">
                                <i class="el-icon-warning"></i>
                                {{ scope.row.expire_date }}
                                <span class="expire-days">{{ expireDaysText(scope.row.expire_date) }}</span>
                            </span>
                        </el-tooltip>
                        <span v-else>{{ scope.row.expire_date || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="balance" label="储值余额" min-width="100" align="right">
                    <template slot-scope="scope">
                        <span class="money-text">{{ formatMoney(scope.row.balance) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="points" label="积分余额" min-width="100" align="right">
                    <template slot-scope="scope">
                        <span class="points-text">{{ scope.row.points || 0 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客户" min-width="140" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ noNameText(scope.row.cust_no, 'cust') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="业务员" min-width="140" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ noNameText(scope.row.salesman_no, 'salesman') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="birthday" label="生日" min-width="110" align="center"></el-table-column>
                <el-table-column prop="region" label="行政区划" min-width="120" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="address" label="详细地址" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" label="门店" min-width="140" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ noNameText(scope.row.store_no, 'store') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="last_active" label="最后活动时间" min-width="150" align="center"></el-table-column>
                <el-table-column prop="build_date" label="创建时间" min-width="150" align="center"></el-table-column>
                <el-table-column label="创建人" min-width="130" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ noNameText(scope.row.build_no, 'staff') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="modify_date" label="修改时间" min-width="150" align="center"></el-table-column>
                <el-table-column label="修改人" min-width="130" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ noNameText(scope.row.modify_no, 'staff') }}</span>
                    </template>
                </el-table-column>
                <!-- 操作列 -->
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button size="mini" type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30, 50]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 新增/编辑抽屉 -->
        <el-drawer :visible.sync="dialogVisible" :show-close="false" :before-close="handleClose" size="680px" :wrapper-closable="false" class="member-drawer">
            <!-- 自定义抽屉头部 -->
            <template slot="title">
                <div class="drawer-header">
                    <div class="drawer-header-left">
                        <i class="el-icon-user-solid"></i>
                        <span>{{ isEdit ? '编辑会员' : '新增会员' }}</span>
                    </div>
                    <i class="el-icon-close drawer-close-btn" @click="handleClose"></i>
                </div>
            </template>
            <!-- 表单内容区 -->
            <div class="drawer-body">
                <el-form ref="form" :model="form" :rules="formRules" label-width="88px" class="drawer-form">
                    <!-- 基本信息 -->
                    <div class="form-card">
                        <div class="form-card-title"><i class="el-icon-user"></i> 基本信息</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="手机号" prop="phone">
                                    <el-input v-model="form.phone" :disabled="isEdit" placeholder="请输入手机号" maxlength="11" prefix-icon="el-icon-phone"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="会员名称" prop="name">
                                    <el-input v-model="form.name" placeholder="请输入会员名称" prefix-icon="el-icon-s-custom">
                                        <el-button slot="append" type="primary" plain icon="el-icon-copy-document" title="取客户名称" @click="fillNameFromCust"></el-button>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="性别" prop="gender">
                                    <el-radio-group v-model="form.gender">
                                        <el-radio :label="1">男</el-radio>
                                        <el-radio :label="2">女</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="生日" prop="birthday">
                                    <el-date-picker v-model="form.birthday" type="date" placeholder="请选择生日" value-format="yyyy-MM-dd" class="full-width" prefix-icon="el-icon-date"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 关联信息 -->
                    <div class="form-card">
                        <div class="form-card-title"><i class="el-icon-connection"></i> 关联信息</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="客户" prop="cust_no">
                                    <el-select v-model="form.cust_no" clearable filterable default-first-option placeholder="请选择客户" class="full-width">
                                        <el-option v-for="(item, index) in pullData.cust" :key="index" :label="item.cust_name" :value="item.cust_no">
                                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.cust_no }}</span>
                                            <span style="margin-left: 10px">{{ item.cust_name }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="业务员" prop="salesman_no">
                                    <el-select v-model="form.salesman_no" clearable filterable default-first-option placeholder="请选择业务员" class="full-width">
                                        <el-option v-for="(item, index) in pullData.salesman" :key="index" :label="item.salesman_name" :value="item.salesman_no">
                                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.salesman_no }}</span>
                                            <span style="margin-left: 10px">{{ item.salesman_name }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="标签" prop="tags">
                                    <el-select v-model="form.tagsArr" multiple placeholder="请选择标签" class="full-width">
                                        <el-option v-for="(item, index) in pullData.tags" :key="index" :label="item.tags_name" :value="item.tags_no">
                                            <span class="tag-option-dot" :style="{ backgroundColor: item.tags_color || '#909399' }"></span>
                                            <span>{{ item.tags_name }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="门店" prop="store_no" v-if="systemSet.isstores == 1">
                                    <el-select v-model="form.store_no" clearable filterable default-first-option placeholder="请选择门店" class="full-width">
                                        <el-option v-for="(item, index) in pullData.store" :key="index" :label="item.store_name" :value="item.store_no">
                                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 地址与备注 -->
                    <div class="form-card">
                        <div class="form-card-title"><i class="el-icon-location-outline"></i> 地址与备注</div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="行政区划" prop="regionArr">
                                    <el-cascader v-model="form.regionArr" :options="regionOptions" clearable placeholder="请选择行政区划" class="full-width"></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="详细地址" prop="address">
                                    <el-input v-model="form.address" placeholder="请输入详细地址" prefix-icon="el-icon-map-location"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('common.remark')" prop="remark">
                                    <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <!-- 底部操作栏 -->
            <div class="drawer-footer">
                <el-button @click="handleClose" icon="el-icon-close">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading" icon="el-icon-check">确 定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiGetMemberList,
    apiCurrentPermisson,
    apiMemberManagePull,
    apiAddMemberData,
    apiUpdateMemberStatus,
    apiUpdateMemberData,
    apiDeleteMemberData
} from '@/request/api';
import { pcaTextArr } from 'element-china-area-data';

export default {
    name: 'memberManage',
    data() {
        return {
            form: {},
            isEdit: false,
            dialogVisible: false,
            submitLoading: false,
            pullData: {},
            regionOptions: pcaTextArr,
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: {},
            pageTotal: 0,
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            formRules: {
                phone: [
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入会员名称', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        // 获取下拉数据
        getPull() {
            apiMemberManagePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apiGetMemberList({
                page: this.pageIndex,
                page_size: this.pageSize,
                seek: this.name
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.msg);
                }
            }).finally(() => {
                this.$load.close();
            });
        },
        // 获取权限
        getPermission() {
            apiCurrentPermisson({
                id: '220'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 状态文本
        statusText(status) {
            const map = { 0: '禁用', 1: '正常', 2: '冻结' };
            return map[status] || '未知';
        },
        // 状态标签类型
        statusTagType(status) {
            const map = { 0: 'danger', 1: 'success', 2: 'warning' };
            return map[status] || 'info';
        },
        // 性别文本
        genderText(gender) {
            const map = { 0: '未知', 1: '男', 2: '女' };
            return map[gender] || '未知';
        },
        // 性别颜色
        genderColor(gender) {
            const map = { 0: '#909399', 1: '#409EFF', 2: '#F56C6C' };
            return map[gender] || '#909399';
        },
        // 解析标签
        parseTags(tags) {
            if (!tags) return [];
            return tags.split(',').filter(t => t.trim());
        },
        // 标签编号转名称
        tagName(tagNo) {
            const list = this.pullData.tags || [];
            const item = list.find(t => String(t.tags_no) === String(tagNo));
            return item ? item.tags_name : tagNo;
        },
        // 标签编号转颜色（未配置颜色时使用默认灰色）
        tagColor(tagNo) {
            const list = this.pullData.tags || [];
            const item = list.find(t => String(t.tags_no) === String(tagNo));
            return (item && item.tags_color) ? item.tags_color : '#909399';
        },
        // 编号转【编号-名称】文本（门店/员工）
        noNameText(no, type) {
            if (!no) return '--';
            const list = this.pullData[type] || [];
            const item = list.find(t => String(t[type + '_no']) === String(no));
            return item ? no + '-' + item[type + '_name'] : no;
        },
        // 计算距离到期日的剩余天数（已过期为负数）
        expireDays(date) {
            if (!date) return null;
            const expire = new Date(String(date).replace(/-/g, '/'));
            expire.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return Math.round((expire - today) / (24 * 60 * 60 * 1000));
        },
        // 是否即将到期（剩余天数 <= 30）
        isExpireSoon(date) {
            if (!date) return false;
            const days = this.expireDays(date);
            return days !== null && days <= 30;
        },
        // 剩余天数文本
        expireDaysText(date) {
            const days = this.expireDays(date);
            if (days === null) return '';
            if (days < 0) return '(已过期' + Math.abs(days) + '天)';
            if (days === 0) return '(今日到期)';
            return '(剩' + days + '天)';
        },
        // 到期悬浮提示
        expireTip(date) {
            const days = this.expireDays(date);
            if (days < 0) return '会员卡已过期' + Math.abs(days) + '天，请及时续费';
            if (days === 0) return '会员卡今日到期，请及时续费';
            return '会员卡距到期还剩' + days + '天，请及时续费';
        },
        // 格式化金额
        formatMoney(val) {
            if (val === null || val === undefined) return '0.00';
            return Number(val).toFixed(2);
        },
        // 搜索
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        // 刷新
        handleRefresh() {
            this.getPull();
            this.getData();
        },
        // 分页
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        },
        // 新增
        handleAdd() {
            this.isEdit = false;
            this.dialogVisible = true;
            this.form = {
                phone: '',
                name: '',
                gender: 0,
                tagsArr: [],
                cust_no: '',
                birthday: '',
                regionArr: [],
                address: '',
                remark: '',
                salesman_no: '',
                store_no: ''
            };
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
                if (this.pullData.store) {
                    const defaultStore = this.pullData.store.find((store) => store.isdefault == 1);
                    this.$set(this.form, 'store_no', defaultStore ? defaultStore.store_no : '');
                }
            });
        },
        // 编辑
        handleEdit(row) {
            this.isEdit = true;
            this.dialogVisible = true;
            this.form = JSON.parse(JSON.stringify(row));
            this.$set(this.form, 'tagsArr', this.parseTags(this.form.tags));
            this.$set(this.form, 'regionArr', this.form.region ? this.form.region.split('/') : []);
            if (!this.form.address) this.$set(this.form, 'address', '');
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        // 会员名称快捷赋值：取客户下拉所选客户名称
        fillNameFromCust() {
            if (!this.form.cust_no) {
                this.$message.warning('请先选择客户');
                return;
            }
            const item = (this.pullData.cust || []).find(t => String(t.cust_no) === String(this.form.cust_no));
            if (item) {
                this.form.name = item.cust_name;
            } else {
                this.$message.warning('未找到该客户信息');
            }
        },
        // 提交表单（新增/编辑共用）
        submitForm() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.submitLoading = true;
                const formData = { ...this.form };
                formData.tags = (formData.tagsArr || []).join(',');
                delete formData.tagsArr;
                formData.region = (formData.regionArr || []).join('/');
                delete formData.regionArr;
                const apiCall = this.isEdit ? apiUpdateMemberData(formData) : apiAddMemberData(formData);
                apiCall.then(res => {
                    if (res.code == 2000) {
                        this.$message.success(this.isEdit ? res.msg : '添加成功');
                        this.dialogVisible = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                }).finally(() => {
                    this.submitLoading = false;
                });
            });
        },
        handleClose() {
            this.form = {};
            this.dialogVisible = false;
        },
        // 删除----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            this.$confirm('确定要删除该会员吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = { id: row.id };
                apiDeleteMemberData(data).then(res => {
                    if (res.code == 2000) {
                        this.$message.success('删除成功');
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            }).catch(() => {});
        }
    }
};
</script>

<style scoped>
.member-page .handle-box {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}
.member-page .handle-input {
    width: 300px;
}
.member-page .mr10 {
    margin-right: 10px;
}
.member-page .table {
    width: 100%;
    font-size: 14px;
    border-radius: 4px;
}
.member-page .tag-item {
    display: inline-block;
    margin: 2px 3px;
    padding: 2px 8px;
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
}
/* 标签下拉选项颜色圆点 */
.member-page .tag-option-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
}
.member-page .text-muted {
    color: #c0c4cc;
    font-size: 13px;
}
.member-page .money-text {
    color: #e6a23c;
    font-weight: 600;
}
.member-page .points-text {
    color: #409EFF;
    font-weight: 600;
}
/* 会员卡临期提示（剩余天数 <= 30） */
.member-page .expire-warn {
    color: #e6a23c;
    font-weight: 700;
    cursor: pointer;
}
.member-page .expire-warn.expire-danger {
    color: #f56c6c;
    animation: expire-blink 1s ease-in-out infinite;
}
.member-page .expire-days {
    font-size: 12px;
    margin-left: 2px;
}
@keyframes expire-blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.45; }
}
.member-page .pagination {
    margin-top: 20px;
    text-align: right;
}
.member-page .full-width {
    width: 100%;
}
</style>
<style>
/* 表格头部样式 */
.member-page .el-table thead {
    color: #303133;
    font-weight: 600;
}
.member-page .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fafafa;
}
.member-page .el-table th {
    background: #f5f7fa !important;
}

/* ===== 抽屉样式 ===== */
.member-drawer .el-drawer__header {
    margin-bottom: 0;
    padding: 0;
    border-bottom: none;
}
.member-drawer .el-drawer__body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
}
/* 抽屉头部 - 蓝色渐变 */
.member-drawer .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    background: linear-gradient(135deg, #409EFF 0%, #2b7de9 100%);
    color: #fff;
}
.member-drawer .drawer-header-left {
    display: flex;
    align-items: center;
    font-size: 17px;
    font-weight: 600;
}
.member-drawer .drawer-header-left i {
    font-size: 20px;
    margin-right: 10px;
}
.member-drawer .drawer-close-btn {
    font-size: 20px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.3s;
}
.member-drawer .drawer-close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
}
/* 抽屉内容区 */
.member-drawer .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 24px 28px;
    background: #f5f7fa;
}
/* 分组卡片 */
.member-drawer .form-card {
    background: #fff;
    border-radius: 10px;
    padding: 24px 28px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.3s;
}
.member-drawer .form-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.member-drawer .form-card:last-child {
    margin-bottom: 0;
}
.member-drawer .form-card-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f2f5;
    display: flex;
    align-items: center;
}
.member-drawer .form-card-title i {
    color: #409EFF;
    margin-right: 8px;
    font-size: 17px;
}
/* 底部操作栏 */
.member-drawer .drawer-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 28px;
    background: #fff;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    gap: 12px;
}
.member-drawer .drawer-footer .el-button {
    min-width: 88px;
}
/* 表单间距优化 */
.member-drawer .drawer-form .el-form-item {
    margin-bottom: 20px;
}
.member-drawer .drawer-form .el-date-editor {
    width: 100% !important;
}

@media screen and (max-width: 768px) {
    .member-drawer .el-drawer {
        width: 100% !important;
    }
    .member-page .el-message-box {
        width: 100%;
    }
    .member-page .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
